import 'deposit/components/CatchPhrase/CatchPhrase.scss';

import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

const CatchPhrase = ({ depositAmount }) => {
    const refundDisclaimer = ContentZonesService.getContentZone('widget.deposit', 'widget.deposit.refund.label')
        ? ContentZonesService.getContentZone('widget.deposit', 'widget.deposit.refund.label').getValue()
        : LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.LIST_GARANTEE');

    return (
        <div className="payment_infos_wrapper">
            <h3 className="sr-subtitle-2">
                {LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.TITLE', {
                    amount: depositAmount,
                })}
            </h3>
            <ul className="payment_infos_wrapper--advantages-listing">
                <li className="sr-text">
                    <icon className="icon-Crochet is-util" />{' '}
                    {LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.LIST_SECURITY')}
                    <a
                        href={LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.PRIVACY_POLICY_URL')}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="sr-link"
                    >
                        {LocaleService.t('DEPOSIT.PAYMENT_INFOS_SECTION.PRIVACY_POLICY')}
                    </a>
                </li>
                <li className="sr-text">
                    <icon className="icon-Crochet is-util" />
                    {refundDisclaimer}
                </li>
            </ul>
        </div>
    );
};

CatchPhrase.propTypes = {
    depositAmount: PropTypes.number.isRequired,
};

CatchPhrase.displayName = 'CatchPhrase';

export default CatchPhrase;



// WEBPACK FOOTER //
// ./src/components/CatchPhrase/CatchPhrase.jsx